import { memo } from 'react';
import classNames from 'classnames';
import { NodeComponent } from '../components/SweepNodeComponent';
import { SweepNodeHandles } from '../SweepNodeHandles';
import { RfNodeReorderNode } from '../../canvas-types/nodeTypesData';
import { NodeProps } from '@xyflow/react';
import { TruncatedTextTooltip } from '../../../common/TruncatedTextTooltip';
import { Box } from '@mui/material';
import { DefaultIcon } from './DefaultIcon';
import { getObjectTypeColor } from '../../helpers/getObjectTypeColor';
import { HoverIcon } from './HoverIcon';

// This is temporary. Need to talk with designers about this
function ColorLuminance(hex: string, lum: number) {
  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  lum = lum || 0;

  // convert to decimal and change luminosity
  let rgb = '#',
    c,
    i;
  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += ('00' + c).substr(c.length);
  }

  return rgb;
}

export const ReorderNode = memo(
  ({ data: { objectType, isNb, name }, dragging }: NodeProps<RfNodeReorderNode>) => {
    const maybeRenderIcon = () => {
      if (!isNb) {
        return (
          <Box position="absolute" top="50%" right="50%" sx={{ transform: 'translate(50%, -50%)' }}>
            {!dragging && (
              <>
                <DefaultIcon
                  color={getObjectTypeColor(objectType).connection}
                  className="default-icon"
                />
                <HoverIcon
                  color={getObjectTypeColor(objectType).connection}
                  className="hover-icon"
                />
              </>
            )}
            {dragging && (
              <HoverIcon
                color={ColorLuminance(getObjectTypeColor(objectType).connection, -0.2)}
                className="hover-icon"
              />
            )}
          </Box>
        );
      }
      return null;
    };
    return (
      <SweepNodeHandles>
        <NodeComponent
          data-testid="sweep-canvas-regular-node"
          className={classNames({
            'nb-node': isNb,
            [`node-${objectType}`]: true,
            shadow: true,
          })}
          sx={{
            '& .hover-icon': {
              display: 'none',
            },
            '& .default-icon': {
              display: 'block',
            },
            '&:hover': {
              cursor: 'pointer',
              '& .hover-icon': {
                display: 'block',
              },
              '& .default-icon': {
                display: 'none',
              },
            },
          }}
        >
          <Box
            component="div"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%',
              padding: '0 27px 0 12px',
              gap: '6px',
            }}
          >
            {maybeRenderIcon()}
            <TruncatedTextTooltip variant="h4">{name}</TruncatedTextTooltip>
          </Box>
        </NodeComponent>
      </SweepNodeHandles>
    );
  },
);
